import React from 'react'
import LayoutHeader from '../../layout/LayoutHeader'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router';
import { sendOtpToEmailThunk, verifyPhone } from '../../store/auth/authThunk';
import RedirectCard from '../../components/More/RedirectCard';

export default function TeamMemberAdvanced() {
    const token = localStorage.getItem('dizeeToken')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userArticle = useSelector((state) => state.user.userArticle);
    const { phone, email } = useSelector((state) => state.user.userArticle);

    const changePhoneNumber = async () => {
        dispatch(verifyPhone(phone));
        navigate('/team-member/verify-old-phone');
    }

    const changeEmail = async () => {
        dispatch(sendOtpToEmailThunk(email));
        navigate('/team-member/verify-old-email');
    }

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className="px-4 my-[50px] flex w-full justify-between">
                    <p className="text-white">Advanced</p>
                    <div className='flex gap-[20px]'>
                        <p onClick={() => navigate('/team-member-dashboard')} className='text-white cursor-pointer'>Go back</p>
                    </div>
                </div>

                <div onClick={changeEmail} className="w-full cursor-pointer">
                    <RedirectCard txt="Update email" dotimgclss={false} link="" />
                </div>

                {phone && (
                    <div onClick={changePhoneNumber} className="w-full cursor-pointer">
                        <RedirectCard txt="Change phone number" dotimgclss={false} link="" />
                    </div>
                )}

                <div onClick={() => navigate('/team-member/deactivate')} className="w-full cursor-pointer">
                    <div className="w-full px-4 py-[14px] border-b border-[#ffffff1a]">
                        <div className="flex justify-between items-center">
                            <p className="text-[#FF4444] text-[12px] leading-[18px]">
                                Close account
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    )
} 